import { ArrowDownward, ArrowDownwardRounded } from "@mui/icons-material";
import { Box, Divider, Typography } from "@mui/material";

import { makeStyles } from "@mui/styles";
import React from "react";
import AunthOptions from "../../../Components/aunthOptions";
import Gene20LinkButton from "../../../Components/gene20LinkButton/gene20LinkButton";
import Navigation from "../presentationNavigation";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
  },
}));

const IntroFooter = (props) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Typography color="secondary" variant="h4">
        greatest mall in town
        <Divider />
      </Typography>
      <Box>
        <Navigation />
        {/* <AunthOptions phone={props.phone} tablet={props.tablet} /> */}
      </Box>
    </Box>
  );
};

export default IntroFooter;
